module.exports = __webpack_public_path__ + "img/down06.64a95c9e.png";